import {findContainer, getDataAttributes, setParamArray} from "./_util";

const VGMap = {
	isInit: false,
	isDebug: false,
	isGlobalInit: false,
	pointCollection: null,
	placeMark: {
		icon: {
			preset: 'islands#icon',
			iconColor: App.themeColor || '#ffffff',
		},
		layout: '',
		image: ''
	},
	cluster: {
		icon: {
			color: App.themeColor || '#ffffff'
		}
	},
	controls: [
		'geolocationControl',
		'searchControl',
		'typeSelector',
		'fullscreenControl',
		'scrollZoom'
	],
	defaults: {
		controls: [],
		zoom: 15,
		mark: 'icon',
		theme: 'default',
		offset: {
			x: [0],
			y: [0]
		},
		sizes: {
			width: [],
			height: []
		},
	},
	permission: {
		isClustered: false,
		isScrollZoom: false,
		isBalloon: false,
		isHint: false,
		isTheme: false
	},
	breakpoints: {
		xs: 0,
		sm: 640,
		md: 767,
		lg: 991,
		xl: 1199,
		xxl: 1399,
		xxxl: 1599
	},

	init: function (map, arg = {}) {
		if (!map) {
			VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
			return false;
		}

		let isYaMaps = true;
		try { if (ymaps) isYaMaps = true; } catch(e) { isYaMaps = false; }

		if (!isYaMaps) {
			VGLog("error", ["Не возможно запустить сервис API Яндекс.Карт!"]);
			return false;
		}

		let params = {}, dataParams = {};

		if (typeof map === 'string') {
			params.map  = findContainer('#' + map);
			params.id   = map;

			if (params.map) dataParams = getDataAttributes(params.map, true);
		} else if (typeof map === 'object') {
			let target = map.getAttribute('id') || null;

			if (!target) {
				VGLog("error", ["Мон Синьор! Путь к карте не найден"]);
				return false;
			}

			params.id   = target;
			params.map  = findContainer('#' + target);
			dataParams  = getDataAttributes(map, true);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.map) {
			VGLog("error", ["Сударь! А где, собственно, карта?"]);
			return false;
		}

		params = Object.assign({}, params, this.defaults, arg, dataParams);

		if ('vg-map' in params) {
			this.isGlobalInit = true;
			delete params['vg-map'];
		}

		/* если много точек на карте */
		if ('points' in params) {
			if (typeof params.points === "string") {
				params.points = JSON.parse(params.points);
			}
		}

		/* размер карты */
		if ('height' in params) {
			params.sizes.height = setParamArray(params.height, true);
			delete params['height'];
		}

		if ('width' in params) {
			params.sizes.width = setParamArray(params.width, true);
			delete params['width'];
		}

		/* смещение карты */
		if ('offset-y' in params) {
			params.offset.y = setParamArray(params['offset-y'], true);
			delete params['offset-y'];
		}
		if ('offset-x' in params) {
			params.offset.x = setParamArray(params['offset-x'],true);
			delete params['offset-x'];
		}

		this.setPermission(params);

		if (this.isDebug) {
			console.log(params);
			console.log(this.permission);
		}

		this.isInit = true;
		this.run(params, arg.callback);
	},

	/**
	 * Устанавливаем разрешения
	 * @param params
	 */
	setPermission: function (params) {
		let _this = this;

		/* нужна ли кластеризация */
		if (('isclustered' in params) || ('isClustered' in params) || ('clustered' in params)) {
			_this.permission.isClustered = true;
			delete params['isclustered'];
			delete params['clustered'];
			delete params['isClustered'];
		}

		/* нужна ли нам балун */
		if (('isballoon' in params) || ('isBalloon' in params) || ('balloon' in params)) {
			_this.permission.isBalloon = true;
			delete params['isballoon'];
			delete params['isBalloon'];
		}

		/* нужен ли зум при скролле */
		if (('is-scroll-zoom' in params) || ('isScrollZoom' in params) || ('isscrollzoom' in params)) {
			_this.permission.isScrollZoom = true;
			delete params['is-scroll-zoom'];
			delete params['isscrollzoom'];
			delete params['isScrollZoom'];
		}

		/* нужна ли нам хинт */
		if ('hint' in params) {
			_this.permission.isHint = true;
		}

		/* Тема оформления карты. На данный момент доступно: grayscale */
		if ('theme' in params && params.theme.length) {
			_this.permission.isTheme = true;
		}
	},

	/**
	 * Возвращает массив с координатами одной точки
	 * @param params
	 * @returns []
	 */
	getCoordinate: function (params) {
		let coordinate = [];

		if ((!params.lat && !params.lon) && ('points' in params)) {
			if (params.points.length && !(params.lat && params.lon)) {
				for (let i = 0; i < params.points.length; i++) {
					if (('lat' in params.points[i]) && ('lon' in params.points[i])) {
						if (i === 0) {
							coordinate.push(params.points[i].lat)
							coordinate.push(params.points[i].lon)
						}
					}
				}
			}
		} else if (params.lat && params.lon) {
			coordinate.push(params.lat)
			coordinate.push(params.lon)
		}

		return coordinate;
	},

	run: function (params, callback) {
		if (!this.isInit) return false;

		const _this = this;

		if (callback) {
			/* колбек после инициализации скрипта, возвращаем объект, разрешения и полученные параметры  */
			if (typeof callback.afterInit === 'function') {
				callback.afterInit(_this, params, _this.permission)
			}
		}

		VGMap.Map.size(params);

		params.coordinate = _this.getCoordinate(params);

		if (params.coordinate.length) {
			ymaps.ready(init);
			function init() {
				if (!_this.isGlobalInit) {
					VGMap.Map.set(params, callback);
				} else {
					let map = VGMap.Map.set(params, callback);

					/* Если много точек собираем их в гео объект */
					if ('points' in params) {
						/* Точек очень много, можно включить кластеризацию */
						if (_this.permission.isClustered) {
							let cluster = new ymaps.Clusterer({
								clusterIconColor: VGMap.cluster.icon.color,
								clusterHideIconOnBalloonOpen: false,
								geoObjectHideIconOnBalloonOpen: false,
							});

							let objects = VGMap.PlaceMark.set(map, params, true);
							cluster.add(objects);
							map.geoObjects.add(cluster);
							map.setBounds(cluster.getBounds());
						} else {
							let objects = VGMap.PlaceMark.set(map, params, true);
							let pointCollection = new ymaps.GeoObjectCollection();

							for (let i in objects) {
								pointCollection.add(objects[i]);
							}

							map.geoObjects.add(pointCollection);
							map.setBounds(map.geoObjects.getBounds());
						}
					} else {
						/* Если точка одна просто покажем ее на карте */
						VGMap.PlaceMark.set(map, params);
					}

					VGMap.Map.offset(map, params);
				}
			}
		} else {
			VGLog("error", ["Ахпер! Гдэ координаты, для карты #"+ params.id +"!"]);
			return false;
		}
	},

	Map: {
		set: function (params, callback) {
			let permission = VGMap.permission;

			let map = new ymaps.Map(params.id, {
				center: params.coordinate,
				zoom: params.zoom,
				controls: ['smallMapDefaultSet'],
			}, {
				searchControlProvider: 'yandex#search',
				suppressMapOpenBlock: true,
			});

			delete params.coordinate;

			/* Отключаем не нужное. Передаем в массив (дата аттрибут), то что не нужно отключать, если нужно отключить всё оставляем пустым */
			VGMap.Map.disabled(map, params.controls);

			if (!permission.isScrollZoom) {
				map.behaviors.disable('scrollZoom');
			}

			if (window.innerWidth < 1000) {
				map.behaviors.get('drag').disable();
			}

			if (permission.isTheme) {
				switch (params.theme) {
					case 'grayscale':
						VGMap.Map.theme(map, 'grayscale');
						break;
				}
			}

			if (callback) {
				/* колбек после инициализации карты, возвращаем карту и полученные параметры  */
				if (typeof callback.afterInitMap === 'function') {
					return callback.afterInitMap(map, params, VGMap)
				}
			}

			return map;
		},

		size: function (params) {
			// todo тут где то есть jquery
			const $map = $(params.map);

			setParamSizes('height', $map.height());
			//setParamSizes('width', $map.width());

			let width = params.sizes.width,
				height = params.sizes.height;

			VGMap.Map.setBreakpoints(setSizes);
			function setSizes(index) {
				let _width = width[index],
					_height = height[index];

				if (_width === undefined) {
					_width = width[width.length - 1];
				}

				if (_height === undefined) {
					_height = height[height.length - 1];
				}

				$map.css('height', _height);
				$map.css('width', _width);
			}

			function setParamSizes(side, value) {
				if (side in params.sizes) {
					let aSide = params.sizes[side]

					if (!aSide.length) {
						if (value === 0) {
							params.sizes[side].push(VGMap.size[side]);
						} else {
							params.sizes[side].push(value);
						}
					}
				}
			}
		},

		disabled: function (map, items = []) {
			// todo тут jquery
			if (items.length > 0) {
				$.each(items, function (i, val) {
					if (VGMap.controls.indexOf(val) > -1) {
						delete VGMap.controls[i];
					}
				});
			}

			$.each(VGMap.controls, function (i, val) {
				if (val !== 'undefined') {
					map.controls.remove(val);
				}
			});
		},

		offset: function (map, params) {
			let offsetX  = params.offset.x,
				offsetY  = params.offset.y;

			VGMap.Map.setBreakpoints(setOffset);

			function setOffset(index) {
				let x = offsetX[index],
					y = offsetY[index];

				if (x === undefined) {
					x = offsetX[offsetX.length - 1];
				}

				if (y === undefined) {
					y = offsetY[offsetY.length - 1];
				}

				let position = map.getGlobalPixelCenter();
				map.setGlobalPixelCenter([position[0] - x, position[1] - y]);
			}
		},

		theme: function (map, theme) {
			if (theme === 'grayscale') {
				map.panes.get('ground').getElement().style.filter = 'grayscale(100%)';
			}
		},

		setBreakpoints: function (func, width = null) {
			if (width) {
				let _breakpoints = Object.keys(VGMap.breakpoints);

				for (let i = 0; i < _breakpoints.length; i++) {
					if (width <= VGMap.breakpoints[_breakpoints[i]]) {
						func(i)
					}
				}
			} else {
				if (window.innerWidth <= VGMap.breakpoints['sm']) {
					func(0);
				} else if (window.innerWidth >= VGMap.breakpoints['sm'] && window.innerWidth <= VGMap.breakpoints['md']) {
					func(1);
				} else if (window.innerWidth >= VGMap.breakpoints['md'] && window.innerWidth <= VGMap.breakpoints['lg']) {
					func(2);
				} else if (window.innerWidth >= VGMap.breakpoints['lg'] && window.innerWidth <= VGMap.breakpoints['xl']) {
					func(3);
				} else if (window.innerWidth >= VGMap.breakpoints['xl'] && window.innerWidth <= VGMap.breakpoints['xxl']) {
					func(4);
				} else if (window.innerWidth >= VGMap.breakpoints['xxl']) {
					func(5);
				}
			}
		}
	},

	PlaceMark: {
		set: function (map, params, isPoints = false) {
			let marker = VGMap.PlaceMark.marker(params);

			if (isPoints) {
				let points = [];

				for (let i = 1; i <= params.points.length; i++) {
					let makerIndex = 0,
						point = params.points[i - 1];

					if (params.mark === 'points') {
						makerIndex = [i - 1]
					}

					points.push(new ymaps.Placemark([point.lat, point.lon], VGMap.PlaceMark.ballon(params, point), marker[makerIndex]));
				}

				map.events.add('click', e => e.get('target').balloon.close());

				return points;
			} else {
				let placeMark = new ymaps.Placemark(
					map.getCenter(), VGMap.PlaceMark.ballon(params), marker[0]
				);

				map.geoObjects.add(placeMark);

				map.events.add('click', e => e.get('target').balloon.close());

				return placeMark;
			}
		},

		marker: function (params) {
			let marker = [];

			if (params.mark === 'layout' && ('mark-layout' in params)) {
				VGMap.placeMark.layout = params['mark-layout'];
				let circleLayout = ymaps.templateLayoutFactory.createClass(VGMap.placeMark.layout);

				marker.push({
					iconLayout: circleLayout
				})
			} else if (params.mark === 'image') {
				if ('mark-image' in params) {
					marker.push(createImageMarker(params['mark-image']))
				}
			} else if (params.mark === 'points') {
				if ('points' in params) {
					for (let point of params.points) {
						if ('marker' in point) {
							marker.push(createImageMarker(point['marker']))
						} else if ('color' in point) {
							marker.push(createColorMarker(point['color']))
						}
					}
				}
			} else if (params.mark === 'icon') {
				let color;

				if ('color' in params) {
					color = params.color;
				} else {
					color = VGMap.placeMark.icon.iconColor;
				}

				marker.push(createColorMarker(color))
			}

			function createImageMarker(image) {
				let marker = {};
				if (typeof image === 'string') {
					image = JSON.parse(image);
				}

				if ('src' in image) {
					marker.iconLayout = 'default#image';
					marker.iconImageHref = image.src;
				} else if ('color' in image) {
					marker.preset = VGMap.placeMark.icon.preset;
					marker.iconColor = image.color;
				}

				if ('size' in image) {
					marker.iconImageSize = image.size;
				}

				if ('offset' in image) {
					marker.iconImageOffset = image.offset;
				}

				return marker;
			}

			function createColorMarker(color) {
				return {
					preset: VGMap.placeMark.icon.preset,
					iconColor: color
				}
			}

			return marker;
		},

		ballon: function (params, point = {}) {
			let content = {}, obj = {};

			if (VGMap.permission.isBalloon) {
				if ('balloon-content' in params) {
					obj = params['balloon-content'];
				} else if ('balloon-content' in point) {
					obj = point['balloon-content'];
				}

				if (obj) {
					content = {
						balloonContent: obj
					}
				}
			}

			if ('title' in point) {
				content['hintContent'] = point['title'];
			}

			if (VGMap.permission.isHint) {
				if ('hint' in params) {
					content['hintContent'] = params['hint'];
				}
			}

			return content;
		}
	},

	Location: {
		init: function (callback) {
			const _this = this;

			let isYaMaps = true;
			try { if (ymaps) isYaMaps = true; } catch(e) { isYaMaps = false; }

			if (!isYaMaps) {
				VGLog("error", ["Не возможно запустить сервис API Яндекс.Карт!"]);
				return false;
			}

			ymaps.ready( function () {
				let geolocation = ymaps.geolocation;

				geolocation.get({
					provider: 'browser'
				}).then(function (result) {
					if (typeof callback === "function") {
						callback(result);
					}
				}, function (err) {
					console.error(err);

					geolocation.get({
						provider: 'yandex'
					}).then(function (result) {
						if (typeof callback === "function") {
							callback(result);
						}
					}, function (err) {
						console.error(err);
					});
				});
			});

			return false;
		}
	}
}

function onReady() {
	let $maps = document.querySelectorAll('[data-vg-map]');
	if ($maps.length) {
		for (let $map of $maps) {
			VGMap.init($map);
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGMap;